import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { menuInfo } from "@shared/type/CommonType";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { fnGetDataSet } from "@shared/api/restApi";
import SearchPanel, { ValueChangedEvent } from "@widgets/SearchPanel";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { showDialog } from "@widgets/CommonDialog";

interface Props {
  Menuprops: menuInfo;
}

// 판매일(월)보(출하기준)
const SN_SAL_ISU_REP_025 = forwardRef(({ Menuprops }: Props, ref) => {
  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData((prev: any) => ({
          ...(rtn.formData || {}),
          ...(prev || {}),
        }));
        setColums({
          grid1: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async () => {
    try {
      const searchInfo = searchRef.current.getFormdata();

      const valid = checkValid();
      if (!valid) return;

      let params;
      switch (searchInfo.cd_radio) {
        case "1":
          params = {
            id: "sn_sal_isu_rep_025_01",
            params: searchInfo,
          };
          break;
        case "2":
          params = {
            id: "sn_sal_isu_rep_025_02",
            params: searchInfo,
          };
          break;
      }

      gridRefs.current["grid1"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0] || [],
      });
    } catch (error: any) {}
  };

  const checkValid = () => {
    const searchInfo = searchRef.current.getFormdata();

    const dt_from1 = searchInfo.dt_from1; // 조회시작일
    const dt_to1 = searchInfo.dt_to1; // 조회종료일
    const dt_from2 = searchInfo.dt_from2; // 월계시작일
    const dt_to2 = searchInfo.dt_to2; // 월계종료일

    // 조회 시작년도와 종료년도 체크
    if (dt_from1.substring(0, 4) !== dt_to1.substring(0, 4)) {
      showDialog("alter", "조회시작년도와 조회종료연도가 일치해야 됩니다.");
      return false;
    }

    // 조회기간이 월계기간 내에 포함되는지 체크
    if (dt_from1 < dt_from2 || dt_to1 > dt_to2) {
      showDialog("alter", "조회기간은 월계기간내에 포함되어야 합니다.");
      return false;
    }

    return true;
  };

  const onValueChanged = (event: ValueChangedEvent) => {
    const { colId, newValue } = event;

    if (colId === "cd_radio") {
      const hideColumnList = [
        "dc_rmk_l",
        "no_io",
        "dt_io",
        "no_line",
        "rt_exch",
        "um",
        "um_supply",
        "dc_rmk_h",
      ];

      const changedColumns = columns.grid1.map((col: any) => {
        if (hideColumnList.includes(col.cd_column)) {
          return {
            ...col,
            fg_visible: newValue === "2" ? "N" : "Y",
          };
        }

        return col;
      });
      setColums({ grid1: changedColumns });
      onSearch();
    }
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {},
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          onValueChanged={onValueChanged}
        ></SearchPanel>
      </div>

      <div className="flex-1 flex flex-col gap-1.5 min-h-0">
        <div className="flex-1 min-h-200">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single" }}
            events={grids.grid1.events}
          />
        </div>
      </div>
    </div>
  );
});

export default SN_SAL_ISU_REP_025;
